import BottomMenu from './BottomMenu';
import LogComponent from './Log';
import LogBookHeader from './LogBookHeader';
import LogsTableHeader from './LogsTableHeader';
import NewLogComponent from './NewLog';
import ReminderLogComponent from './ReminderLog';
import { $reminders, $view, removeReminder } from '@/stores';
import { logs } from '@/stores/logbook';
import { useSubscribe } from '@/utils/useSubscribe';
import { useStore } from '@nanostores/react';
import { useEffect, useRef } from 'react';

export function LogsComponent() {
  const view = useStore($view);
  const reminders = useStore($reminders);
  useSubscribe(logs);
  const bottomRef = useRef<HTMLTableRowElement>(null);

  const all = view === 'audit' ? logs.getAllLogs() : logs.withGeneratedLogs();

  let msgNum = 0;

  // Auto-scroll to bottom in officer view when logs update
  useEffect(() => {
    if (view !== 'officer' || !bottomRef.current) {
      return;
    }
    // only scroll if already near the bottom
    if (
      bottomRef.current.getBoundingClientRect().top - window.innerHeight >
      100
    ) {
      return;
    }
    bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [all.length, view]);

  return (
    <>
      <div className="grow overflow-auto">
        <table className="min-w-full">
          <thead className="print:table-header-group">
            <LogBookHeader />
            <tr>
              <td colSpan={6} className="h-4" />
            </tr>
            <LogsTableHeader />
          </thead>
          <tbody>
            {all.map((log, index) => {
              if (log.type === 'message') msgNum++;
              return (
                <LogComponent
                  key={
                    log.id + '-' + ('entries' in log ? log.entries.length : 0)
                  }
                  log={log}
                  num={msgNum}
                  index={index}
                />
              );
            })}
            {view === 'operator' &&
              reminders.map(reminder => (
                <ReminderLogComponent
                  key={reminder.id}
                  reminder={reminder}
                  onDismiss={() => removeReminder(reminder.id)}
                />
              ))}
            {view === 'operator' && <NewLogComponent />}
            {view === 'officer' && <tr ref={bottomRef} />}
          </tbody>
        </table>
        {view === 'operator' && (
          <div className="h-[calc(100%-41px-53.5px)] print:hidden" />
        )}
      </div>
      {view === 'operator' && <BottomMenu />}
    </>
  );
}
